<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard">
        <p-toast key="toastmsg"></p-toast>

        <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>Batch Enrolment - <span>{{userName | titlecase}}</span>
                    <span> ({{profileDetails?.mobileNumber}})</span>
                    <span class="badge">{{ totalRecords }}</span></h4>
            </div>

            <div class="rightDiv">
                <button class="exportBTn" pTooltip="XLS" tooltipPosition="bottom" (click)="exportExcel()"> <span><img
                            src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
                    Export</button>
            </div>
        </div>

        <div class="mainDivBody">
            <div class="date-filterDiv">
                <ul class="filtersList">
                    <li>
                        <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby" placeholder="Select Field"
                            optionLabel="label"></p-dropdown>
                    </li>
                    <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
                            [showIcon]="true" placeholder="FROM: dd / mm / yy"></p-calendar>
                    </li>
                    <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                            [showIcon]="true" placeholder="To: dd / mm / yy"></p-calendar>
                    </li>
                    <li>
                        <!-- <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-" (click)="loadWallet($event)"></button> -->
                        <button (click)="loadUserBatchEnrolments($event)" class="searchFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                        </button>
                    </li>
                    <li>
                        <!-- <button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-filter-slash" (click)="clear()"></button> -->
                        <button (click)="clear()" class="clearFilterBtn">
                            <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                            <span>Clear All</span>
                        </button>
                    </li>
                </ul>
            </div>

            <div class="maintableDiv">
                <div class="tableParanet">
                    <p-table class=" expandable" #dt [value]="batchEnrolmentList" [paginator]="true" [rows]="10"
                        [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
                        (onLazyLoad)="loadUserBatchEnrolments($event)" [totalRecords]="totalRecords" [loading]="loading"
                        [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th pfrozencolumn="" class="p-element BatchName" style="left: 0px;" pSortableColumn="amount">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Batch Name
                                        <p-sortIcon field="amount"></p-sortIcon>
                                    </div>
                                </th>
                                <th class="col-180 AcademyName" pSortableColumn="invoiceId">
                                    <div class="p-d-flex p-jc-between p-ai-center ">
                                        Academy Name
                                        <p-sortIcon field="invoiceId"></p-sortIcon>
                                    </div>
                                </th>
                                <th class="col-180" pSortableColumn="receiptId">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Level
                                        <p-sortIcon field="receiptId"></p-sortIcon>
                                    </div>
                                </th>
                                <th class="col-150" pSortableColumn="paymentId">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Age Group
                                        <p-sortIcon field="paymentId"></p-sortIcon>
                                    </div>
                                </th>
                                <th class="col-150" pSortableColumn="transactionDate">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Start Date
                                        <p-sortIcon field="transactionDate"></p-sortIcon>
                                    </div>
                                </th>

                                <th pSortableColumn="expiryDate" class="col-180">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        End Date
                                        <p-sortIcon field="expiryDate"></p-sortIcon>
                                    </div>
                                </th>
                                <th class="col-180" pSortableColumn="invoiceId">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        State
                                        <p-sortIcon field="invoiceId"></p-sortIcon>
                                    </div>
                                </th>
                                <th class="col-180" pSortableColumn="invoiceId"
                                    [ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        City
                                        <p-sortIcon field="invoiceId"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="status" class="statusTD"
                                    [ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Batch Status
                                        <p-sortIcon field="status"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="status" class="statusTD"
                                    [ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Payment Mode
                                        <p-sortIcon field="status"></p-sortIcon>
                                    </div>
                                </th>
                                <th class="actionTD text-nowrap p-element p-frozen-column" pfrozencolumn=""
                                    alignfrozen="right">
                                    <div class="p-d-flex p-jc-between p-ai-center">
                                        Action
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th [ngSwitch]="batch" pfrozencolumn="" class="BatchName">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'batch', 'contains')"
                                        [value]="dt.filters['batch'] ? dt.filters['batch'].value : ''" />
                                </th>
                                <th [ngSwitch]="academyName" class="col-180 AcademyName">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyName', 'contains')"
                                        [value]="dt.filters['academyName'] ? dt.filters['academyName'].value : ''" />
                                </th>
                                <th [ngSwitch]="level" class="col-180">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'level', 'contains')"
                                        [value]="dt.filters['level'] ? dt.filters['level'].value : ''" />
                                </th>
                                <th [ngSwitch]="ageGroup" class="col-150">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'ageGroup', 'contains')"
                                        [value]="dt.filters['ageGroup'] ? dt.filters['ageGroup'].value : ''" />
                                </th>
                                <th [ngSwitch]="startDate" class="col-150">
                                    <!-- <p-calendar #pCalendarId class="p-column-filter" readonlyInput="true"
                                        inputId="calendar" dateFormat="dd-mm-yy"
                                        (onSelect)="setDownloadFlag(); dt.filter($event,'startDate', 'dateIs')"
                                        [showIcon]="true" appendTo="body" monthNavigator="true" yearNavigator="true"
                                        yearRange="2000:2030" showButtonBar="true"
                                        [(ngModel)]="transvalue"></p-calendar> -->
                                </th>

                                <th [ngSwitch]="endDate" class="col-180">
                                    <!-- <p-calendar #pCalendarId class="p-column-filter" readonlyInput="true"
                                        inputId="calendar" dateFormat="dd-mm-yy"
                                        (onSelect)="setDownloadFlag(); dt.filter($event,'endDate', 'dateIs')"
                                        [showIcon]="true" appendTo="body" monthNavigator="true" yearNavigator="true"
                                        yearRange="2000:2030" showButtonBar="true"
                                        [(ngModel)]="expiryvalue"></p-calendar> -->
                                </th>
                                <th [ngSwitch]="statename" class="col-180">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'statename', 'contains')"
                                        [value]="dt.filters['statename'] ? dt.filters['statename'].value : ''" />
                                </th>
                                <th [ngSwitch]="cityname" class="col-180"
                                    [ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
                                    <input pInputText type="text"
                                        (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'cityname', 'contains')"
                                        [value]="dt.filters['cityname'] ? dt.filters['cityname'].value : ''" />
                                </th>
                                <th [ngSwitch]="batchStatus" class="statusTD"
                                    [ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
                                    <p-dropdown #pDropDownId1 [options]="statuses"
                                        (onChange)="setDownloadFlag(); dt.filter($event.value, 'batchStatus', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select Status" [showClear]="true"
                                        appendTo="body">
                                        <ng-template let-option pTemplate="item">
                                            <span
                                                [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                        </ng-template>
                                    </p-dropdown>
                                </th>
                                <th [ngSwitch]="paymentDone" class="statusTD"
                                    [ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
                                    <p-dropdown #pDropDownId2 [options]="paymentModes"
                                        (onChange)="setDownloadFlag(); dt.filter($event.value, 'paymentDone', 'equals')"
                                        styleClass="p-column-filter" placeholder="Select payment mode" [showClear]="true"
                                        appendTo="body">
                                        <ng-template let-option pTemplate="item">
                                            <span
                                                [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                        </ng-template>
                                    </p-dropdown>
                                </th>
                                	<th class="p-frozen-column">
									<div class="buttonColumn">
										<button class="addBTn" (click)="addColumns()"
											[ngClass]="hide ? 'show-column ' : 'hide-column'">
											+ Show Column
										</button>
										<button class="removeBTn" (click)="removeColumns()"
											[ngClass]="hide ? 'hide-column' : 'show-column '">
											- Hide Column
										</button>

									</div>
								</th>

                                <!-- <th class="actionTD text-nowrap p-element p-frozen-column" pfrozencolumn=""
                                    alignfrozen="right">
                                    <button pButton pRipple label="Columns" icon="pi pi-plus"
                                        [ngClass]="hide ? 'show-col p-button p-button-secondary p-button-rounded ' : 'hide-col p-button-secondary p-button-rounded'"
                                        (click)="setDownloadFlag(); addColumns()"></button>
                                    <button pButton pRipple label="Columns" icon="pi pi-minus"
                                        [ngClass]="hide ? 'hide-col p-button p-button-rounded' : 'show-col p-button p-button-rounded'"
                                        (click)="setDownloadFlag(); removeColumns()"></button>
                                </th> -->
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-user>
                            <tr class="p-selectable-row">
                                <td pfrozencolumn="" class="BatchName" style="left: 0px; z-index: 1001; display: flex;">
                                    {{user?.batch}}
                                </td>
                                <td class="col-180 AcademyName">
                                    {{user?.academyName}}
                                </td>
                                <td class="col-180">
                                    {{user?.level}}
                                </td>
                                <td class="col-150">
                                    {{user?.ageGroup}}
                                </td>
                                <td class="col-150">
                                    {{user?.startDate| date: 'dd/MM/yyyy'}}
                                </td>

                                <td class="col-180">
                                    {{user?.endDate| date: 'dd/MM/yyyy'}}
                                </td>
                                <td class="col-180">
                                    {{user?.statename}}
                                </td>
                                <td class="col-180"
                                    [ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
                                    {{user?.cityname}}
                                </td>
                                <td class="statusTD"
                                    [ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
                                    <div class="checkbox p-d-flex align-items-center">
                                        <span>{{ user?.batchStatus }}</span>
                                    </div>
                                </td>
                                <td class="statusTD"
                                    [ngClass]="hide ? 'hide-col text-nowrap col-200 ' : 'show-col text-nowrap col-200'">
                                    <div class="checkbox p-d-flex align-items-center">
                                        <span>{{ user?.paymentDone }}</span>
                                    </div>
                                </td>

                                <td class="actionTD text-nowrap p-element p-frozen-column" pfrozencolumn=""
                                    alignfrozen="right">
                                    <ul class="actionList">
                                        <li>
                                            <a [href]="user?.invoiceFile" target="_blank" download>
                                                <button class="downloadbtn">
                                                    <img
                                                        src="../../../../../assets/images/backend-image/common-images/downloadbtn.svg">
                                                </button>
                                            </a>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7">Batch Enrolment not found.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>



        <p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>
        <p-dialog [(visible)]="editTransaction" [modal]="true" [style]="{width: '400px'}" header="Edit Payment Details"
            [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false"
            [resizable]="false" (onHide)="editTransactionClose()" id="dateChangePopup">
            <form [formGroup]="editPaymentForm" *ngIf="this.editPaymentForm">
                <div>
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12">
                            <label for="amount">Start Date: <span class="mandatory-fields">*</span></label>
                            <p-calendar appendTo="body" placeholder="Select Subscription Start Date"
                                formControlName="transactionDate" class="p-column-filter" monthNavigator="true"
                                yearNavigator="true" yearRange="{{yearRange}}" inputId="calendar" dateFormat="dd-mm-yy"
                                [readonlyInput]="true" [showIcon]="true" (onSelect)="setStartDate($event)"
                                [ngClass]="{ 'is-invalid': transactionSubmitted && f.transactionDate.errors }"
                                [minDate]="minimumDate">
                            </p-calendar>
                            <div *ngIf="transactionSubmitted && f.transactionDate.errors" class="invalid-feedback">
                                <div *ngIf="f.transactionDate.errors.required">Subscription Start Date is required</div>
                                <div *ngIf="f.transactionDate.errors.startDateError">Start Date should be less than End
                                    Date
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12">
                            <label for="enddt">End Date: <span class="mandatory-fields">*</span></label>
                            <p-calendar appendTo="body" placeholder="Select Subscription End Date"
                                formControlName="expiryDate" class="p-column-filter" monthNavigator="true"
                                yearNavigator="true" yearRange="{{yearRange}}" inputId="calendar" dateFormat="dd-mm-yy"
                                [readonlyInput]="true" [showIcon]="true" (onSelect)="setEndDate($event)"
                                [ngClass]="{ 'is-invalid': transactionSubmitted && f.expiryDate.errors }"
                                [minDate]="minimumDate">
                            </p-calendar>
                            <div *ngIf="transactionSubmitted && f.expiryDate.errors" class="invalid-feedback">
                                <div *ngIf="f.expiryDate.errors.required">Subscription End Date is required</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modalFooter">
                    <button type="button" (click)="onSubmit()" pButtonlabel="Submit" pButton label="Submit"
                        class="saveBtn" style="width: auto"></button>
                </div>

            </form>
        </p-dialog>
    </div>
</div>